import BaseAvatar, { AvatarProps as BaseAvatarProps } from '@mui/material/Avatar'
import * as React from 'react'

export interface AvatarProps extends BaseAvatarProps {
  bustingKey?: string | number
}

export const Avatar: React.FC<AvatarProps> = ({ src, bustingKey, ...rest }) => {
  const cacheBustedSrc = React.useMemo(() => {
    if (!src) return src

    if (src.startsWith('blob:') || src.startsWith('data:')) {
      return src
    }

    try {
      const url = new URL(src, window.location.origin)
      url.searchParams.set('_cb', String(bustingKey ?? Date.now()))
      return url.toString()
    } catch {
      // fallback if src is not a valid URL (like base64)
      const sep = src.includes('?') ? '&' : '?'
      return `${src}${sep}_cb=${bustingKey ?? Date.now()}`
    }
  }, [src, bustingKey])

  return <BaseAvatar src={cacheBustedSrc} {...rest} />
}
